<script setup>
import { defineProps } from "vue";
import PaymentHistoryTable from "@/components/table/PaymentHistoryTable.vue";

// Define props
const props = defineProps({
  client_id: String,
  show_popup: Boolean,
  client_firstname: String,
  client_lastname: String,
  client_middlename: String,
  client_username: String,
  client_phone: String,
});

// Format full name
const fullName = `${props.client_lastname || ''} ${props.client_firstname || ''} ${props.client_middlename || ''}`.trim();
</script>

<template>
  <div class="modal fade" id="info" tabindex="-1" aria-labelledby="clientInfoModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 shadow rounded-4">
        <!-- Modal Header with Avatar -->
        <div class="modal-header border-0 bg-primary bg-opacity-10 px-4 py-4">
          <div class="d-flex align-items-center">
            <div class="client-avatar rounded-circle bg-primary d-flex align-items-center justify-content-center me-3">
              <i class="bi bi-person-fill fs-4"></i>
            </div>
            <div>
              <h5 class="modal-title fs-4 fw-semibold mb-1 text-black" id="clientInfoModalLabel">Карточка клиента</h5>
              <p class="text-muted mb-0">
                <small><i class="bi bi-person-vcard me-1"></i> ID: {{ props.client_id }}</small>
              </p>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-4">
          <!-- Client Information Card -->
          <div class="card border-0 bg-light rounded-4 mb-4">
            <div class="card-body p-4">
              <h6 class="text-primary mb-3">Личные данные</h6>

              <div class="row g-3">
                <!-- Full Name -->
                <div class="col-md-12">
                  <div class="client-info-item">
                    <label class="info-label">
                      <i class="bi bi-person me-2"></i>ФИО
                    </label>
                    <p class="info-value">{{ fullName || '—' }}</p>
                  </div>
                </div>

                <!-- Government ID -->
                <div class="col-md-6">
                  <div class="client-info-item">
                    <label class="info-label">
                      <i class="bi bi-upc-scan me-2"></i>ИИН
                    </label>
                    <p class="info-value">{{ props.client_username || '—' }}</p>
                  </div>
                </div>

                <!-- Phone Number -->
                <div class="col-md-6">
                  <div class="client-info-item">
                    <label class="info-label">
                      <i class="bi bi-telephone me-2"></i>Телефон
                    </label>
                    <p class="info-value">
                      <a v-if="props.client_phone" :href="`tel:${props.client_phone}`" class="text-decoration-none">
                        {{ props.client_phone }}
                      </a>
                      <span v-else>—</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Payment History Section -->
          <div class="payment-history-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="text-primary mb-0">
                <i class="bi bi-cash-coin me-2"></i>История платежей
              </h6>
            </div>

            <payment-history-table
                :client_id="props.client_id"
            >
            </payment-history-table>
          </div>
        </div>

<!--        <div class="modal-footer border-0 px-4 py-3">-->
<!--          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">-->
<!--            <i class="bi bi-x me-1"></i>Закрыть-->
<!--          </button>-->
<!--          <button type="button" class="btn btn-primary">-->
<!--            <i class="bi bi-printer me-1"></i>Печать данных-->
<!--          </button>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-content {
  overflow: hidden;
}

.client-avatar {
  width: 50px;
  height: 50px;
  font-size: 1.5rem;
}

.client-info-item {
  margin-bottom: 0.5rem;
}

.info-label {
  display: block;
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}

.info-value {
  font-weight: 500;
  margin-bottom: 0;
  font-size: 1rem;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .client-avatar {
    width: 40px;
    height: 40px;
  }

  .modal-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .modal-header .btn-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  .modal-title {
    margin-top: 0.5rem;
  }
}
</style>